@if (isReady) {
<div id="sidebar">
  <header>
    <h2>{{ "settings.components" | transloco }}</h2>
    <div class="ui pointing secondary menu">
      <div
        class="item categories"
        (click)="activeTab = 'categories'"
        [ngClass]="{ active: activeTab === 'categories' }"
      >
        {{ "settings.categories" | transloco }}
      </div>
      <div
        class="item questions"
        (click)="activeTab = 'questions'"
        [ngClass]="{ active: activeTab === 'questions' }"
      >
        {{ "settings.questions" | transloco }}
      </div>
    </div>
  </header>
  <div
    class="ui tab categories"
    [ngClass]="{ active: activeTab === 'categories' }"
  >
    <div class="tab-contents">
      <div class="content hidden-scrollbar">
        @if (categories?.length > 0) {
        <div class="header">
          <div class="search">
            <div class="ui left icon input">
              <i class="search icon"></i>
              <input
                id="category-search"
                type="text"
                [(ngModel)]="categorySearch"
                placeholder="{{ 'settings.search-categories' | transloco }}"
              />
            </div>
          </div>
          @if (!isProductionMode) {
          <div (click)="showCreateCategoryModal()" class="ui primary button">
            {{ "settings.create-new" | transloco }}
          </div>
          }
        </div>
        <div class="list">
          @for (category of categories|keyWord:['name']:categorySearch; track
          category) {
          <div class="item">
            {{ category?.name }}
          </div>
          }
        </div>
        } @if (categories?.length === 0) {
        <div
          *ngTemplateOutlet="noResults; context: { type: 'categorie' }"
        ></div>
        }
      </div>
    </div>
  </div>
  <div
    class="ui tab questions"
    [ngClass]="{ active: activeTab === 'questions' }"
  >
    <div class="tab-contents">
      <div class="content hidden-scrollbar">
        @if (questions?.length > 0) {
        <div class="header">
          <div class="search">
            <div class="ui left icon input">
              <i class="search icon"></i>
              <input
                id="question-search"
                type="text"
                [(ngModel)]="questionSearch"
                placeholder="{{ 'settings.search-questions' | transloco }}"
              />
            </div>
          </div>
          @if (!isProductionMode) {
          <a
            [routerLink]="['/settings', 'client-rules', 'questions', 'new']"
            [queryParams]="getTaxYearParam()"
            target="_blank"
            class="ui primary button"
            >{{ "settings.create-new" | transloco }}</a
          >
          }
        </div>
        <div class="list">
          @for (question of questions|keyWord:['question']:questionSearch; track
          question) {
          <div class="item">
            @if (showQuestionId) {
            <span>{{ question?.id }}.</span>
            } {{ question?.question }}
          </div>
          }
        </div>
        } @if (questions?.length === 0) {
        <div *ngTemplateOutlet="noResults; context: { type: 'question' }"></div>
        }
      </div>
    </div>
  </div>
</div>
} @if (isReady) {
<div id="content" class="hidden-scrollbar">
  <header>
    <h2>{{ "settings.client-rules-structure" | transloco }}</h2>
    <div>
      @if (!isProductionMode) {
      <div
        (click)="save()"
        class="ui primary save button"
        [ngClass]="{ loading: isSaving }"
      >
        {{ "settings.save" | transloco }}
      </div>
      }
    </div>
  </header>
  <div id="body">
    <div id="form-structure">
      @for (category of categories; track category) {
      <div class="listing">
        <div
          (click)="editNode(category)"
          class="category item"
          [ngClass]="{ selected: selectedNode?.category?.id === category?.id }"
        >
          <div>{{ category.name }}</div>
          <div>
            <div class="count">
              {{ category.questions?.length || 0 }}
              {{ category.questions?.length === 1 ? "Question" : "Questions" }}
            </div>
            <div [ngClass]="{ hidden: category.questions?.length === 0 }">
              <i
                class="chevron icon"
                [ngClass]="{
                  down: category.isCollapsed,
                  up: !category.isCollapsed
                }"
              ></i>
            </div>
          </div>
          <div
            (click)="showConfirmDeleteModal('category', category)"
            class="delete"
            [ngClass]="{ hidden: category.id }"
          >
            <div class="delete icon"></div>
          </div>
          <div class="order">
            {{ category.order == null ? "null" : category.order }}.
          </div>
        </div>
        @if (category.questions?.length > 0 && !category.isCollapsed) {
        <div class="listing">
          @for (question of category.questions; track question) {
          <div
            class="question item"
            [ngClass]="{
              selected: selectedNode?.question?.id === question?.id,
              'column-q': question.parentId
            }"
            (click)="editNode(null, question)"
          >
            <div class="question-lbl">
              <div class="question">
                @if (showQuestionId) {
                <span>{{ question.id }}.</span>
                } {{ question.question }}
                <div class="question-type">{{ getQuestionType(question) }}</div>
              </div>
              <div class="dep-mandatory-lbl">
                @if (question.dependantMandatoryParentId) {
                <span
                  title="This question is only mandatory dependant on another question"
                  >D</span
                >
                }
              </div>
            </div>
            <div class="mandatory">
              {{ question.mandatory ? "Mandatory" : "Optional" }}
            </div>
            <div
              class="delete"
              (click)="showConfirmDeleteModal('question', question, category)"
              [ngClass]="{ hidden: !question.canRemove && !isProductionMode }"
            >
              <div class="delete icon"></div>
            </div>
            <div class="order">
              {{ question.order == null ? "null" : question.order }}.
            </div>
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    <div id="settings">
      @if (!selectedNode?.category && !selectedNode?.question &&
      !isProductionMode) {
      <div (click)="showCreateCategoryModal()" class="ui primary button">
        {{ "settings.add-category" | transloco }}
      </div>
      } @if (selectedNode?.category) {
      <div>
        <header>
          <div class="sub-title">{{ "settings.category" | transloco }}</div>
          <div>
            <h3>{{ selectedNode?.category?.name }}</h3>
            @if (!isProductionMode) {
            <span (click)="showEditModal()" class="edit-btn">{{
              "settings.edit" | transloco
            }}</span>
            }
          </div>
          @if (!isProductionMode) {
          <div
            (click)="showAddQuestionToCategoryModal()"
            class="ui primary button"
          >
            {{ "settings.add-question" | transloco }}
          </div>
          }
        </header>
      </div>
      } @if (selectedNode?.question) {
      <div>
        <header>
          <div class="sub-title">{{ "settings.question" | transloco }}</div>
          <div>
            <h3>{{ selectedNode?.question?.question }}</h3>
            @if (!isProductionMode) {
            <span (click)="showEditModal()" class="edit-btn">{{
              "settings.edit" | transloco
            }}</span>
            }
          </div>
        </header>
      </div>
      }
    </div>
  </div>
</div>
}

<ng-template #noResults let-type="type">
  <div class="no-results">
    {{ 'settings.no-type-s-found' | transloco: {type} }}
  </div>
</ng-template>

<div id="modals-container">
  <div #newCategoryModal id="new-category-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    <h1>{{ "settings.create-new-category" | transloco }}</h1>

    <form (ngSubmit)="addCategory()">
      <div>
        <label>{{ "settings.category-name" | transloco }}</label>
        <input type="text" [(ngModel)]="newCategoryName" name="name" />
      </div>

      <div>
        <label>{{ "settings.category-order" | transloco }}</label>
        <input
          type="number"
          min="1"
          [(ngModel)]="newCategoryOrder"
          name="order"
        />
      </div>

      <div class="actions">
        <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
        <button
          class="ui primary background button"
          [ngClass]="{ disabled: !newCategoryName }"
        >
          {{ "settings.create" | transloco }}
        </button>
      </div>
    </form>
  </div>

  <div
    #addQuestionToCategoryModal
    id="add-question-to-category-modal"
    class="ui tiny modal"
  >
    <div class="icon modal-close close"></div>

    <div class="header">
      <h2>{{ "settings.select-question" | transloco }}</h2>
      <div class="search">
        <div class="ui left icon input">
          <i class="search icon"></i>
          <input
            type="text"
            [(ngModel)]="addCategoryQuestionSearch"
            placeholder="{{ 'settings.search-questions' | transloco }}"
          />
        </div>
      </div>
    </div>

    @if (selectedNode?.category) {
    <div class="list">
      @for (question of
      questions|keyWord:['question']:addCategoryQuestionSearch; track question)
      { @if (canAddQuestion(question)) {
      <div class="item" (click)="addQuestionToCategory(question)">
        <div>
          {{ question?.question }}
          <div class="question-type">{{ getQuestionType(question) }}</div>
        </div>
        <div class="mandatory">
          {{ question?.mandatory ? "Mandatory" : "Optional" }}
          <span
            class="dot"
            [ngClass]="{ 'top-level': question.topLevel }"
          ></span>
        </div>
      </div>
      } }
    </div>
    }
  </div>

  <div #editModal id="edit-modal" class="ui tiny modal edit">
    <div (click)="reset()" class="icon modal-close close"></div>

    <h1>
      {{
        "settings.edit-selected-node-type"
          | transloco: { type: selectedNode?.type }
      }}
    </h1>

    @if (selectedNode) {
    <form>
      @if (selectedNode.category) {
      <div>
        <label>{{ "settings.category-name" | transloco }}</label>
        <input
          type="text"
          [(ngModel)]="selectedNode.category.newCategoryName"
          name="name"
        />
      </div>
      <div>
        <label>{{ "settings.category-order" | transloco }}</label>
        <input
          type="number"
          min="1"
          [(ngModel)]="selectedNode.category.newCategoryOrder"
          name="order"
        />
      </div>
      } @if (selectedNode.question) {
      <div>
        <label>{{ "settings.order" | transloco }}</label>
        <input
          type="number"
          min="1"
          [(ngModel)]="selectedNode.question.newQuestionOrder"
          name="order"
        />
      </div>
      }
      <div class="actions">
        <span class="go-back deny cancel">{{
          "settings.cancel" | transloco
        }}</span>
        @if (selectedNode.category) {
        <button
          class="ui primary background approve button"
          [ngClass]="{ disabled: !selectedNode?.category?.newCategoryName }"
        >
          {{ "settings.continue" | transloco }}
        </button>
        } @if (selectedNode.question) {
        <button class="ui primary background approve button">
          {{ "settings.continue" | transloco }}
        </button>
        }
      </div>
    </form>
    }
  </div>

  <div #confirmDeleteModal id="confirm-delete-modal" class="ui tiny modal">
    <div class="icon modal-close close"></div>

    <div class="content">
      <h3>{{ "settings.are-you-sure-you-want-to-remove-this" | transloco }}</h3>
    </div>

    <div class="actions">
      <span class="go-back cancel">{{ "settings.cancel" | transloco }}</span>
      <div class="ui primary background approve button">
        {{ "settings.yes-remove" | transloco }}
      </div>
    </div>
  </div>
</div>

@if (!isReady) {
<div class="ui active inverted dimmer">
  <div class="ui large loader"></div>
</div>
}
